
import { supabase } from "@/integrations/supabase/client";

export function useVerifyUser(fetchUsers: () => void) {
  const verifyUser = async (userId: string, onFinish?: () => void) => {
    try {
      const { error } = await supabase
        .from("profiles")
        .update({ verified: true })
        .eq("id", userId);
      if (error) throw error;
      fetchUsers();
      if (onFinish) onFinish();
    } catch (error: any) {
      console.error("Failed to verify user:", error);
    }
  };
  return { verifyUser };
}
